import athleteResult from '@/store/modules/athlete-result/athlete-result'
import athleteResultById from '@/store/modules/athlete-result/athlete-result-by-id'
import athleteResultCreate from '@/store/modules/athlete-result/athlete-result-create'
import athleteResultDelete from '@/store/modules/athlete-result/athlete-result-delete'
import athleteResultEdit from '@/store/modules/athlete-result/athlete-result-edit'

export default {
  athleteResult,
  athleteResultById,
  athleteResultCreate,
  athleteResultDelete,
  athleteResultEdit
}
